import React, { Component } from "react";
import Window from "../2/Controls/Window";
import Input from "../2/Controls/Input";
import "./GCLookUp.css";
import { searchPincodeGlobalCatalog } from "../../services/api/PincodeAPI";

class GCLookup extends Component {
  constructor() {
    super();
    this.state = {
      searchText: "",
      products: [],
    };
    this.search = this.search.bind(this);
  }

  componentDidMount() {
    let searchText = this.props.GCLookupText ? this.props.GCLookupText : "";
    this.setState({
      searchText: searchText,
    });
    this.search(searchText);
  }

  async search(searchText) {
    if (searchText.trim() === "") {
      this.setState({ products: [], loading: false });
      return;
    }
    this.setState({ loading: true });
    let result = await searchPincodeGlobalCatalog(
      "",
      "",
      "barcode",
      searchText
    );
    let products = [];
    if (result && result.length > 0) {
      result.map((m) => {
        m.DisplayName = m.Name + " " + m.Quantity + " " + m.UOM;
        products.push(m);
      });
    }
    this.setState({ products: products, loading: false });
  }

  render() {
    return (
      <Window
        header={"Catalogue Search"}
        modal={true}
        width={"600px"}
        height={"600px"}
        onClose={() => this.props.onClose()}
        onButtonClick={(buttonType) => {}}
        buttons={[]}
        slide={true}
      >
        <div className="row">
          <div className="col-md-12">
            <Input
              type="text"
              placeholder="Search by product name or code"
              value={this.state.searchText}
              onChange={(value) => this.setState({ searchText: value })}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button
              className="btn btn-primary pull-right"
              onClick={() =>
                this.search(this.state.searchText, this.state.selectedOption)
              }
            >
              Search
            </button>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-12">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th></th>
                  <th>Product Details</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.products.map((m, index) => (
                  <tr key={"tdtr" + index}>
                    <td>
                      <img src={m.Image} className="list-page-image" />
                    </td>
                    <td>
                      <div>{m.DisplayName}</div>
                      <div>{m.Code}</div>
                      <div>MRP: {m.MRP}</div>
                    </td>
                    <td>
                      <button
                        className="btn btn-primary pull-right"
                        onClick={() => this.props.onSelect(m)}
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Window>
    );
  }
}
export default GCLookup;
